import { loadingBarReducer } from 'react-redux-loading-bar';
import * as PageRedux from '../pagesContents/Page/redux';
import * as LoginRedux from '../pagesContents/Login/redux';
import * as AboutRedux from '../pagesContents/About/redux';
import * as ScholarshipRedux from '../pagesContents/Scholarship/redux';
import * as SubmitSchoolRedux from '../pagesContents/SubmitSchool/redux';
import * as DisclaimerRedux from '../pagesContents/Disclaimer/redux';
import * as StartRedux from '../pagesContents/Start/redux';
import * as ApplicationCvRedux from '../pagesContents/ApplicationCv/redux';
import * as ApplicationBackgroundRedux from '../pagesContents/ApplicationBackground/redux';
import * as ApplicationPersonalRedux from '../pagesContents/ApplicationPersonal/redux';
import * as ApplicationSubmitRedux from '../pagesContents/ApplicationSubmit/redux';
import * as ThankyouRedux from '../pagesContents/Thankyou/redux';
import * as ForgotPasswordRedux from '../pagesContents/ForgotPassword/redux';
import * as ResetPasswordRedux from '../pagesContents/ResetPassword/redux';
import * as PrintCandidacyRedux from '../pagesContents/PrintCandidacy/redux';
import * as ApiRedux from './api/redux';
import * as AppRedux from './app/redux';
import * as I18nRedux from './i18n/redux';
import * as AuthRedux from './auth/redux';
import * as TrackingRedux from './tracking/redux';
var entities = [{
  key: 'loadingBar',
  reducer: loadingBarReducer
}, PageRedux, LoginRedux, AboutRedux, ScholarshipRedux, SubmitSchoolRedux, DisclaimerRedux, StartRedux, ApplicationCvRedux, ApplicationBackgroundRedux, ApplicationPersonalRedux, ApplicationSubmitRedux, ThankyouRedux, ForgotPasswordRedux, ResetPasswordRedux, PrintCandidacyRedux, ApiRedux, AppRedux, I18nRedux, AuthRedux, TrackingRedux];
var reducers = entities.reduce(function (acc, entity) {
  if (!entity.key) {
    console.error('Missing entity key');
  }
  acc[entity.key] = entity.reducer;
  return acc;
}, {});
export default reducers;